import React from 'react';
import { connect } from 'react-redux';

import { withError } from '../../shared/components/error-boundary';
import '../css/product-results.less';


class ProductResults extends React.PureComponent {
    static defaultProps = {
        className: 'product-results'
    }
    render() {
        const {
            leftMenuActive,
            className
        } = this.props;
        const tabClassName =
            leftMenuActive ?
                " left-menu-open" : ""; ``
        return (
            <div className={`product-results${className ? ` ${className}` : ''}${tabClassName ? ` ${tabClassName}` : ''}`}>
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { leftMenu } = state;
    return {
        leftMenuActive: leftMenu.active,
    };
};

export default connect(mapStateToProps, undefined)(withError(ProductResults));